document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('variant-radios, variant-selects').forEach(function (variantElement) {
    var jsonEl = variantElement.querySelector('[type="application/json"]');
    if (!jsonEl) return;

    var variantData = JSON.parse(jsonEl.textContent);
    var isRadios = variantElement.tagName.toLowerCase() === 'variant-radios';

    // ── On option1 change: auto-switch remaining options to first available combination ──
    // Uses capture phase so the radio/select values are updated BEFORE onVariantChange
    // calls updateOptions() to read them.
    variantElement.addEventListener('change', function (event) {
      if (isRadios) {
        var fieldsets = Array.from(variantElement.querySelectorAll('fieldset'));
        if (fieldsets.length < 2) return;
        // Only react when the first option (e.g. color) changed
        if (!fieldsets[0].contains(event.target)) return;

        var selectedOption1 = event.target.value;
        var best = variantData.find(function (v) {
          return v.option1 === selectedOption1 && v.available;
        });
        if (!best) return;

        // Set all subsequent option fieldsets to match the best available variant
        for (var i = 1; i < fieldsets.length; i++) {
          var val = best['option' + (i + 1)];
          if (!val) continue;
          var radio = fieldsets[i].querySelector('input[value="' + val + '"]');
          if (radio && !radio.checked) radio.checked = true;
        }
        // No extra dispatch needed — the current event continues bubbling
        // and onVariantChange will call updateOptions() reading the updated radios.

      } else {
        var selects = Array.from(variantElement.querySelectorAll('select'));
        if (selects.length < 2 || event.target !== selects[0]) return;

        var selectedOption1 = selects[0].value;
        var best = variantData.find(function (v) {
          return v.option1 === selectedOption1 && v.available;
        });
        if (!best) return;

        for (var i = 1; i < selects.length; i++) {
          var val = best['option' + (i + 1)];
          if (val) selects[i].value = val;
        }
        // Event continues bubbling; onVariantChange reads updated select values.
      }
    }, true); // true = capture phase, runs before the bubble-phase onVariantChange listener
  });
});
